import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomInput from '../theme/style-components/CustomInput';
import CustomButton from '../theme/style-components/CustomButton';
import { useEmailVerificationMutation } from '../store/auth/authApiSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';

const EmailVerify = ({ email }) => {
  const [verifyEmail, { isLoading }] = useEmailVerificationMutation();
  const navigate = useNavigate();

  const validationSchema = yup.object({
    otp: yup
      .string()
      .required('Please enter the OTP')
      .matches(/^\d{6}$/, 'OTP must be exactly 6 digits'),
  });

  const formik = useFormik({
    initialValues: {
      email: email || '',
      otp: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const res = await verifyEmail({ email: values.email, otp: values.otp }).unwrap();
        toast.success(res?.message || 'Email verified!');
        navigate('/'); // Redirect after successful verification
      } catch (err) {
        toast.error(err?.data?.message || 'Verification failed');
      }
    },
  });

  // Only allow numbers and max 6 digits in the input
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    formik.setFieldValue('otp', value);
  };

  return (
    <Box>
      <Box sx={{ marginBottom: '20px', justifyContent: 'center', display: 'flex' }}>
        <Typography variant="h5">Verify your email</Typography>
      </Box>
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ marginBottom: '15px' }}>
          <CustomInput
            id="email"
            name="email"
            label="Email"
            variant="outlined"
            margin="normal"
            value={formik.values.email}
            onChange={formik.handleChange}
            required
            fullWidth
            disabled
          />
        </Box>
        <Box sx={{ marginBottom: '15px' }}>
          <CustomInput
            id="otp"
            name="otp"
            label="OTP"
            variant="outlined"
            margin="normal"
            placeholder="Enter OTP"
            value={formik.values.otp}
            onChange={handleOtpChange}
            error={formik.touched.otp && Boolean(formik.errors.otp)}
            helperText={formik.touched.otp && formik.errors.otp}
            required
            fullWidth
            type="tel"
            inputProps={{ maxLength: 6, pattern: '[0-9]*', inputMode: 'numeric' }}
          />
        </Box>
        <Box sx={{ marginTop: '10px' }}>
          <CustomButton
            fullWidth
            disabled={isLoading || !formik.isValid}
            size="large"
            color="primary"
            onClick={formik.handleSubmit}
            buttonName={isLoading ? 'Verifying...' : 'Verify Email'}
          />
        </Box>
      </form>
    </Box>
  );
};

export default EmailVerify; 